import OpensansBold from './Opensans-Bold.ttf'
import OpensansRegular from './Opensans-Regular.ttf'
import OpensansItalic from './Opensans-Italic.ttf'
import OpensansLight from './Opensans-Light.ttf'
import OpensansLightItalic from './Opensans-LightItalic.ttf'
import OpensansSemibold from './Opensans-Semibold.ttf'
import OpensansSemiboldItalic from './Opensans-SemiboldItalic.ttf'

export default {
  OpensansBold,
  OpensansRegular,
  OpensansItalic,
  OpensansLight,
  OpensansLightItalic,
  OpensansSemibold,
  OpensansSemiboldItalic,
}

import { injectGlobal } from 'styled-components'

injectGlobal`
  @font-face {
    font-family: 'OpensansBold';
    font-style: normal;
    font-weight: bold;
    src: local('OpensansBold'), url(${OpensansBold}) format('truetype');
  }

  @font-face {
    font-family: 'OpensansRegular';
    font-style: normal;
    font-weight: regular;
    src: local('OpensansRegular'), url(${OpensansRegular}) format('truetype');
  }

  @font-face {
    font-family: 'OpensansItalic';
    font-style: italic;
    font-weight: regular;
    src: local('OpensansItalic'), url(${OpensansItalic}) format('truetype');
  }

  @font-face {
    font-family: 'OpensansLightItalic';
    font-style: italic;
    font-weight: regular;
    src: local('OpensansLightItalic'), url(${OpensansLightItalic}) format('truetype');
  }

  @font-face {
    font-family: 'OpensansLight';
    font-style: noraml;
    font-weight: regular;
    src: local('OpensansLight'), url(${OpensansLight}) format('truetype');
  }

  @font-face {
    font-family: 'OpensansSemibold';
    font-style: normal;
    font-weight: bold;
    src: local('OpensansSemibold'), url(${OpensansSemibold}) format('truetype');
  }

  @font-face {
    font-family: 'OpensansSemiboldItalic';
    font-style: italic;
    font-weight: bold;
    src: local('OpensansSemiboldItalic'), url(${OpensansSemiboldItalic}) format('truetype');
  }
`



// WEBPACK FOOTER //
// ./assets/fonts/index.js